var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-size"},_vm._l((_vm.variants),function(item,index){return _c('button',{key:index,staticClass:"product-size__value",class:{'_active': _vm.selected === item},attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('selectVariant', item)}}},[_vm._v(_vm._s(item.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }